// Reference Guide Types
export enum ReferenceGuideType {
  HorizontalPlane,
  VerticalPlane,
  Edge,
  Cube,
  HorizontalEdge,
}
